export default __webpack_public_path__ + "static/media/discord.f412dad9.svg";